module.exports = __webpack_public_path__ + "img/icon-mobile-sign.eece411d.svg";